import { appGroupIdFigmaOauthStatus } from "@dashboardApi/apis/appGroupIdFigmaOauthStatus";

import type { AllRouteEndpoints } from "../routeTypes";

export const deleteAppGroupIdFigmaOauthDisconnectCacheKeys: AllRouteEndpoints[] = [appGroupIdFigmaOauthStatus];
